const SeasonalArt = () => null;
export default SeasonalArt;
